import type { GetPaymentsParams } from './types';

export const paymentKeys = {
  all: ['payments'] as const,
  lists: () => [...paymentKeys.all, 'list'] as const,
  list: (filters?: GetPaymentsParams) => [...paymentKeys.lists(), filters] as const,
  details: () => [...paymentKeys.all, 'detail'] as const,
  detail: (id: string) => [...paymentKeys.details(), id] as const,
  documents: (paymentId: string) => [...paymentKeys.detail(paymentId), 'documents'] as const,
  creators: () => [...paymentKeys.all, 'creators'] as const,
  bankAccounts: (creatorId: string) => [...paymentKeys.all, 'bank-accounts', creatorId] as const,
};

